import { useEffect, useState } from 'react';
import { AVATAR_SIZE } from '@vidmakr/shared';
import { Avatar, Button, Card, Field, Input, PageHeader } from '@/components/ui';
import { ImagePicker } from '@/components/ImagePicker';
import { McpKeysCard } from '@/components/McpKeys';
import { DesktopAppCard } from '@/components/DesktopApp';
import { NotificationSettingsCard } from '@/components/Notifications';
import { useAccount } from '@/lib/hooks';
import { useSession } from '@/lib/session';
import { reducers } from '@/lib/stdb';
import { attempt } from '@/lib/toast';

export function AccountPage() {
  const { account } = useAccount();
  const refresh = useSession((s) => s.load);
  const [name, setName] = useState('');
  useEffect(() => setName(account?.name ?? ''), [account?.name]);
  if (!account) return null;
  const saveAvatar = async (avatarUrl: string) => {
    if (await attempt(() => reducers().updateProfile({ name: account.name, avatarUrl }), avatarUrl ? 'Avatar updated' : 'Avatar removed')) void refresh();
  };
  return (
    <>
      <PageHeader title="Account" subtitle={account.email} />
      <Card className="max-w-xl p-5">
        <div className="mb-5 flex items-center gap-4">
          <ImagePicker
            url={account.avatarUrl}
            endpoint="/avatar"
            maxPx={AVATAR_SIZE}
            size={72}
            round
            label="avatar"
            fallback={<Avatar name={account.name || account.email} size={72} />}
            onChange={saveAvatar}
          />
          <div>
            <div className="font-semibold">{account.name}</div>
            <div className="text-sm text-muted">{account.email}</div>
            <div className="mt-1 text-xs text-faint">Click or drop an image to change your avatar.</div>
          </div>
        </div>
        <div className="space-y-4">
          <Field label="Display name">
            <Input value={name} onChange={(e) => setName(e.target.value)} maxLength={80} />
          </Field>
          <Button
            variant="primary"
            disabled={!name.trim() || name === account.name}
            onClick={async () => {
              if (await attempt(() => reducers().updateProfile({ name, avatarUrl: account.avatarUrl }), 'Profile saved')) void refresh();
            }}
          >
            Save
          </Button>
        </div>
      </Card>
      <NotificationSettingsCard />
      {account.impersonatedBy ? null : <McpKeysCard />}
      <DesktopAppCard />
    </>
  );
}
